
























import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import {Organisation} from '@/types';
import UserService from '@/services/user.service';

@Component({})
export default class AccOrgAutocomplete extends Vue {
  @Prop({default: 'Account / Organisation'}) private placeholder!: string;
  @Prop({default: 'Account / Organisation'}) private label!: string;
  @Prop({default: false}) private accountSubscriptions!: boolean;
  @Prop({default: true}) private dense!: boolean;
  @Prop({default: true}) private outlined!: boolean;
  @Prop({default: false}) private hideDetails!: boolean;
  @Prop({default: false}) private clearable!: boolean;
  @Prop({default: false}) private disabled!: boolean;
  @Prop({default: true}) private accountSelectable!: boolean;
  @Prop({default: null}) private value!: {id: number; is_org: boolean};

  @Getter private organisations: any;

  private orgList: any[] = [];
  private innerValue: {id: number; is_org: boolean} | null = null;

  private mounted() {
    this.innerValue = this.value;
  }

  @Watch('innerValue')
  private onValueChanged(val: number) {
    this.$emit('input', val);
  }

  private getAccNameFromOrg(org: any): string {
    return org.billing_account_id ? org.billing_account.name : '[No account]';
  }

  private get itemList() {
    const noAccount = '[No account]';

    if (this.accountSubscriptions) {
      return this.organisations.organisations
        .map((org: Organisation) => ({
          text: org.name,
          billing_account: org.billing_account ? this.getAccNameFromOrg(org) : noAccount,
          is_org: true,
          value: { id: org.id, is_org: true },
        }))
        .sort((a: {text: string}, b: {text: string}) => a.text.localeCompare(b.text));
    }

    const accountMap: Record<string, { accountId: number | null, organisations: Organisation[] }> = {};
    this.organisations.organisations.forEach((org: Organisation) => {
      const accountName = org.billing_account ? this.getAccNameFromOrg(org) : noAccount;
      const accountId = org.billing_account ? org.billing_account.id : null;
      if (!accountMap[accountName]) {
        accountMap[accountName] = { accountId, organisations: [] };
      }
      accountMap[accountName].organisations.push(org);
    });

    const sortedAccounts = Object.keys(accountMap)
        .filter((account) => account !== noAccount)
        .sort();
    const accountsOrder = [noAccount, ...sortedAccounts];

    const items: any[] = [];

    accountsOrder.forEach((accountName) => {
      const entry = accountMap[accountName] || { accountId: null, organisations: [] };
      const { accountId, organisations } = entry;

      items.push({
        text: accountName,
        is_org: false,
        value: { is_org: false, id: accountId },
      });

      organisations.sort((a, b) => a.name.localeCompare(b.name));
      organisations.forEach((org) => {
        items.push({
          text: org.name,
          billing_account: this.accountSelectable ? accountName : undefined,
          is_org: true,
          value: { id: org.id, is_org: true },
        });
      });
    });
    return items;
  }
}
